import { render, staticRenderFns } from "./scrollview.vue?vue&type=template&id=70d8ebe9&scoped=true"
import script from "./scrollview.vue?vue&type=script&lang=js"
export * from "./scrollview.vue?vue&type=script&lang=js"
import style0 from "./scrollview.vue?vue&type=style&index=0&id=70d8ebe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8ebe9",
  null
  
)

export default component.exports